import { TextField } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { ChangeEvent, CSSProperties, useState } from 'react'

import ModalActionContainer from 'components/containers/modalActionContainer'

interface Props {
  onCancel: () => void
  onSave: (data: { name: string }) => void
}
export default function SecurityFieldRegisterModal(props: Props) {
  const [securityFieldName, setSecurityFieldName] = useState('')
  const handleSaveClick = () => {
    props.onSave({
      name: securityFieldName,
    })
  }

  const handleChangeName = (e: ChangeEvent<HTMLInputElement>) => {
    setSecurityFieldName(e.target.value)
  }

  return (
    <Box style={containerStyle}>
      <TextField
        variant="standard"
        id="securityFieldName"
        label="警備先名"
        onChange={handleChangeName}
      />
      <ModalActionContainer>
        <Button variant="negative" onClick={props.onCancel}>
          キャンセル
        </Button>
        <Button variant="contained" onClick={handleSaveClick}>
          保存
        </Button>
      </ModalActionContainer>
    </Box>
  )
}

const containerStyle: CSSProperties = {
  paddingTop: '8px',
}
